import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Download } from 'lucide-react';
import { checkForFlexibleUpdate, completeFlexibleUpdate } from '../../lib/appUpdate';
import { useLanguage } from '../../hooks/useLanguage';

// Drives the Play flexible-update flow and shows a non-blocking "restart to
// update" snackbar once the new version has downloaded in the background.
const UpdatePrompt: React.FC = () => {
  const { t } = useLanguage();
  const [ready, setReady] = useState(false);

  useEffect(() => { checkForFlexibleUpdate(() => setReady(true)); }, []);

  return (
    <AnimatePresence>
      {ready && (
        <motion.div
          initial={{ y: 80, opacity: 0 }} animate={{ y: 0, opacity: 1 }} exit={{ y: 80, opacity: 0 }}
          className="fixed left-3 right-3 bottom-[calc(var(--sai-bottom)+0.75rem)] z-[70] flex items-center gap-3 bg-safaricab-card border border-white/10 rounded-2xl px-4 py-3 shadow-2xl"
        >
          <Download className="w-5 h-5 text-safaricab-gold flex-shrink-0" />
          <p className="flex-1 text-white text-sm">{t('update_ready_msg')}</p>
          <button onClick={() => completeFlexibleUpdate()}
            className="bg-safaricab-gold text-black font-bold text-sm px-4 py-2 rounded-xl flex-shrink-0">
            {t('update_restart_btn')}
          </button>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default UpdatePrompt;
